import React from "react";
import styles from "./ReportTable.module.css";

/**
 * Common BRSR report table (no MUI).
 * @param {Array<{field:string,label:string,width?:string,align?:'left'|'center'|'right'}>} columns
 * @param {Array<object>} rows
 * @param {string|null} title
 * @param {string|null} subTitle
 * @param {boolean} showSerialNumber
 * @param {(row:any, columnField:string, rowIndex:number) => React.ReactNode} renderCell
 */
const ReportTable = ({
  columns = [],
  rows = [],
  title = null,
  subTitle = null,
  showSerialNumber = true,
  renderCell,
  helperText = null,
}) => {
  const tableColumns = showSerialNumber
    ? [{ field: "sno", label: "S.No.", width: "60px", align: "center" }, ...columns]
    : columns;

  const getCellContent = (row, column, rowIndex) => {
    if (column.field === "sno") return `${rowIndex + 1}.`;
    if (renderCell) return renderCell(row, column.field, rowIndex);
    const v = row?.[column.field];
    return v === null || v === undefined || v === "" ? "-" : String(v);
  };

  return (
    <div className={styles.wrapper}>
      {title ? <div className={styles.title}>{title}</div> : null}
      {subTitle ? <div className={styles.subTitle}>{subTitle}</div> : null}
      {helperText ? <div className={styles.subTitle}>{helperText}</div> : null}

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr className={styles.headerRow}>
              {tableColumns.map((col) => (
                <th
                  key={col.field}
                  className={`${styles.headerCell} ${
                    col.field === "sno" ? styles.headerCellSno : ""
                  }`}
                  style={{
                    width: col.width || "auto",
                    textAlign: col.align || (col.field === "sno" ? "center" : "left"),
                  }}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows && rows.length ? (
              rows.map((row, rowIndex) => (
                <tr key={row?._id || rowIndex} className={styles.bodyRow}>
                  {tableColumns.map((col) => (
                    <td
                      key={col.field}
                      className={`${styles.cell} ${
                        col.field === "sno" ? styles.cellSno : ""
                      }`}
                      style={{
                        textAlign:
                          col.align || (col.field === "sno" ? "center" : "left"),
                        width: col.width || "auto",
                      }}
                    >
                      {getCellContent(row, col, rowIndex)}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  className={`${styles.emptyCell} noDataCell`}
                  colSpan={tableColumns.length}
                >
                  No information provided.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportTable;

